import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default class ComboSlot extends ItemsV3Serializer {
  normalize(type, data) {
    // name was being initialized as undefined when it was not provided
    data.name = data.name ?? null;
    data.default_item_variation_id = data.default_item_variation_id ?? null;
    return super.normalize(type, data);
  }
}